import styled from 'styled-components';

import MyReport from './meunItem/MyReport';
import MfReport from './meunItem/Mfreport';
import MyTeam from './meunItem/MyTeam';
import Personal from './meunItem/PersonalInfo';
import MfInfo from './meunItem/MfInfo';
import UploadAvater from './meunItem/UploadAvater';
import SetPassword from './meunItem/SetPassword';
import SidebarMenu from './components/Menu';
import {Team} from './meunItem/Team'

// import { useTranslation } from 'react-i18next';
import { useEffect, useLayoutEffect, useState } from 'react';
import { Layout } from 'antd';
import { useSelector } from 'react-redux';
import { currentToken, currentUser } from '../../features/user/userSlice';
import {useNavigate, useLocation, useSearchParams} from 'react-router-dom';
import {Policy} from "./meunItem/Policy";
import { TwoFA } from './meunItem/TwoFA';
import {MfAdministrator} from "./meunItem/MfAdministrator";

const { Content, Sider } = Layout;

const UserContinar = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 50px;
`;

const els = [
  { key: 'my_report', el: <MyReport /> },
  { key: 'team', el: <Team /> },
  { key: 'my_team', el: <MyTeam /> },
  { key: 'my_info', el: <Personal /> },
  { key: 'policy', el: <Policy /> },
  { key: '2fa', el: <TwoFA /> },
  // { key: 'set_avater', el: <UploadAvater /> },
  { key: 'set_passeord', el: <SetPassword /> },
  { key: 'mf_report', el: <MyReport /> },
  { key: 'mf_info', el: <MfInfo /> },
  { key: 'mf_administrator', el: <MfAdministrator /> },
  // { key: 'mf_set_logo', el: <UploadAvater /> },
  { key: 'mf_set_passeord', el: <SetPassword /> },
];

const UserCenter = () => {
  // const { t, i18n } = useTranslation();
  const [params] = useSearchParams()
  const [collapsed, setCollapsed] = useState(false);
  const [element, setElement] = useState(null);
  const [fromAddteam, setFromAddteam] = useState(false);
  const [toWallet, setToWallet] = useState(false);
  const token = useSelector(currentToken);
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector(currentUser);
  const [_key, setKey] = useState(params.get('page') ?? (user?.user.type === 0 ? 'my_report' : 'my_report'));

  useLayoutEffect(() => {
    if (location.state && location.state.from === '/addteam') {
      setKey('my_team');
      setFromAddteam(true);
    } else {
      setFromAddteam(false);
    }
    if (location.state && location.state.wallet_address) {
      setToWallet(true);
      setKey('my_info');
    } else {
      setToWallet(false);
    }

  }, []);

  const resizeChange = (e) => {
    e.preventDefault();
    const el = document.documentElement;
    if (el.clientWidth < 1200) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  };

  useEffect(() => {
    const el = document.documentElement;
    if (el.clientWidth < 1200) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
    window.addEventListener('resize', resizeChange, { passive: false });
    return () => {
      window.removeEventListener('resize', resizeChange);
    };
  }, []);

  useLayoutEffect(() => {
    const _el = els.find((item, index) => item.key === _key).el;
    setElement(_el);
  }, [_key]);

  useEffect(() => {
    if (!token) {
      navigate('/', { replace: true });
    }
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleItemClick = (e) => {
    // console.log(e.key);
    setKey(e.key);
  };
  return (
      <UserContinar>
        <Layout>
          <Sider
              className="user-sider"
              collapsible
              collapsed={collapsed}
              onCollapse={(value) => setCollapsed(value)}
              theme={'dark'}
          >
            <SidebarMenu
                defaultPage={_key}
                menuItemClick={handleItemClick}
                fromAddteam={fromAddteam}
                toWallet={toWallet}
            />
          </Sider>
          <Layout
              className="user-content"
              style={{
                overflowY: 'auto',
              }}
          >
            <Content className="side-content">{element}</Content>
          </Layout>
        </Layout>
      </UserContinar>
  );
};

export default UserCenter;
